import { useTranslation } from 'react-i18next';

interface StampProgressProps {
  activeStamps: number;
  requiredStamps: number;
  progress: number;
}

export default function StampProgress({ activeStamps, requiredStamps, progress }: StampProgressProps) {
  const { t } = useTranslation();

  return (
    <div className="space-y-3">
      {/* Progress Bar */}
      <div className="relative">
        <div className="h-3 bg-surface-2 rounded-full overflow-hidden">
          <div
            className="h-full transition-all duration-500"
            style={{ width: `${Math.min(progress, 100)}%` }}
          />
        </div>
        <div className="absolute -top-1 right-0 text-xs font-medium text-ink-muted">
          {activeStamps} / {requiredStamps}
        </div>
      </div>

      {/* Stamps Grid */}
      <div className="grid grid-cols-5 gap-4 mt-4">
        {Array.from({ length: requiredStamps }).map((_, index) => {
          const isEarned = index < activeStamps;
          return (
            <div
              key={index}
              className={`
                aspect-square rounded-lg flex items-center justify-center transition-all overflow-hidden
                ${isEarned
                  ? 'scale-105 shadow-lg ring-2 ring-accent'
                  : 'bg-surface-2 border-2 border-dashed border-hairline opacity-40'
                }
              `}
            >
              <img
                src="/logo_w.webp"
                alt="Monkey Barber"
                className={`w-full h-full object-contain p-1 ${isEarned ? 'opacity-100' : 'opacity-30 grayscale'}`}
              />
            </div>
          );
        })}
      </div>

      {/* Message */}
      <div className="text-center">
        {activeStamps >= requiredStamps ? (
          <p className="text-sm font-medium text-success">
            {t('loyalty.card.rewardAvailable')}
          </p>
        ) : (
          <p className="text-sm text-ink-muted">
            {t('loyalty.card.stampsToNext', { count: requiredStamps - activeStamps })}
          </p>
        )}
      </div>
    </div>
  );
}
